/**
 * @GENERATED from Figma node 3608:51008
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleDriveDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#EA4335"
      d="M19.535 21.773c.34-.207.63-.491.832-.853l.403-.711 1.928-3.426A2.4 2.4 0 0 0 23 15.62h-6.93l1.474 2.973z"
    />
    <path
      fill="#0066DA"
      d="m2.663 19.2.97 1.72c.202.362.492.646.832.853L7.93 15.62H1c0 .4.1.801.302 1.163z"
    />
    <path
      fill="#00AC47"
      d="M12 8.38 8.535 2.227c-.34.207-.63.491-.832.853l-6.4 11.376A2.4 2.4 0 0 0 1 15.62h6.93z"
    />
    <path
      fill="#2684FC"
      d="M16.07 15.62H7.93l-3.465 6.153c.34.207.73.31 1.134.31h12.802a2.3 2.3 0 0 0 1.134-.31z"
    />
    <path
      fill="#00832D"
      d="m12 8.38 3.465-6.153c-.34-.207-.73-.31-1.134-.31H9.669a2.3 2.3 0 0 0-1.134.31z"
    />
    <path
      fill="#FFBA00"
      d="m19.497 8.768-3.2-5.688a2.3 2.3 0 0 0-.832-.853L12 8.38l4.07 7.24h6.918c0-.401-.101-.802-.303-1.164z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleDriveDark);
export { ForwardRef as GoogleDriveDark };
